import { getComplianceEvaluationReasonsStats } from 'frontend/communications/stats'

const stateObj = {
  positiveEvaluationStats: {},
  negativeEvaluationStats: {},
}

const getters = {
  getCompliancePositiveEvaluationStats (state) {
    return state.positiveEvaluationStats
  },
  getComplianceNegativeEvaluationStats (state) {
    return state.negativeEvaluationStats
  },
}

const mutations = {
  setComplianceEvaluationStats (state, value) {
    state.positiveEvaluationStats = value.positive_reasons
    state.negativeEvaluationStats = value.negative_reasons
  },
}
const actions = {
  async fetchComplianceEvaluationReasonsStats ({ commit }, payload) {
    const response = await getComplianceEvaluationReasonsStats(payload['perimeterIds'])
    commit('setComplianceEvaluationStats', response)
    return response
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
